import mergeConfig from 'coact/config/mergeConfig'

import ReferenceQueryPage from './ReferenceQueryPage/index.js'
import saga from './saga.js'

const config = {
  routes: {
    referenceQuery: {
      title: '採購參考資料查詢',
      path: '/route/referenceQuery',
      component: ReferenceQueryPage,
    },
  },
  sagas: {
    referenceQuerySaga: saga,
  },
}

export default fullConfig => mergeConfig(fullConfig, config)
